// extracted by mini-css-extract-plugin
module.exports = {"badgeWrapper":"_3leGbPop-kmyJftjZ8SgAx","badgeImage":"_2GtJPRwcW9V4zjoX9LV6ag","badgeShadow":"S5aN-iSSZ2MnA7e6yMT1","badgeContent":"_1Pcb37mLGNBmDtnjiYJlan"};